import { populate, selectView, toggle } from 'reducers/viewerInsights';

export const toggleViewerInsightsUI = toggle;
export const populateViewerInsightsViewers = populate;
export const selectInsightsView = selectView;
